module.exports = __webpack_public_path__ + "static/KY-b9b13415c42e11ec27c63b5b695da00a.svg";